import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CtaButton } from './CTASection.styles';

interface ButtonProps {
  buttonName: string;
  type: 'primary' | 'secondary';
  isMarketUSA: boolean;
  isSticky?: boolean;
  digitalLeadsData?: string;
  redirectUrl?: string;
  isPreOwned?: boolean;
  weblink?: string;
  correctDealerListingUrl?: string;
  bookATestDriveUrl?: string;
  contactDealerUrl?: string;
}

// ASK PAVEL
const Button: React.FC<ButtonProps> = ({
  buttonName,
  type,
  isMarketUSA,
  isSticky,
  digitalLeadsData,
  isPreOwned,
  weblink,
  correctDealerListingUrl,
  bookATestDriveUrl,
  contactDealerUrl,
}) => {
  const { i18n } = useTranslation();
  const lang = i18n.languages?.[0] || 'en';
  // ASK PAVEL
  // @ts-ignore
  const windowVisitor = typeof window !== 'undefined' ? window?.ss?.visitor : '';
  const mcvid = windowVisitor?.getMarketingCloudVisitorID();
  const mcvidParam = mcvid ? `mcvid=${mcvid}` : '';
  const weblinkWithDDC = weblink?.includes('?')
    ? weblink?.concat(`&ddcref=tier1_inventorysearch&${mcvidParam}`)
    : weblink?.concat(`?ddcref=tier1_inventorysearch&${mcvidParam}`);

  const { t } = useTranslation();
  const contactDealerButton = (
    <CtaButton
      type={type}
      // Contact Dealer URL? ASK PAVEL
      // eslint-disable-next-line no-script-url
      href={isMarketUSA ? 'javascript:void(0)' : contactDealerUrl}
      sticky={isSticky}
      data-testid="contact-dealer-button"
      id="digital-leads"
      data-info={digitalLeadsData}
    >
      {t('vehiclePricingBar.dealerListPrice.contactDealer')}
    </CtaButton>
  );

  const visitDealerListingButton = (
    <CtaButton
      type={type}
      // ASK PAVEL
      href={correctDealerListingUrl}
      sticky={isSticky}
      data-testid="visit-dealer-website-button"
    >
      {t('vehiclePricingBar.dealerListPrice.visitDealerListing')}
    </CtaButton>
  );

  const bookATestDriveButton = (
    <CtaButton
      type={type}
      // ASK PAVEL
      href={bookATestDriveUrl}
      sticky={isSticky}
      data-testid="book-test-drive-button"
    >
      {t('vehiclePricingBar.dealerListPrice.bookATestDrive')}
    </CtaButton>
  );
  if (buttonName === 'CONTACT_DEALER') return contactDealerButton;
  if (buttonName === 'VISIT_DEALER') return visitDealerListingButton;
  if (buttonName === 'BOOK_TEST_DRIVE') return bookATestDriveButton;
  return null;
};

export default Button;
